var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#006699"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23934 16.8632V10.3801H7.08638V16.8632H9.23957H9.23934ZM8.16331 9.4951C8.91394 9.4951 9.38125 8.99727 9.38125 8.37513C9.3672 7.73881 8.91394 7.25488 8.17758 7.25488C7.44073 7.25488 6.95947 7.73881 6.95947 8.37507C6.95947 8.99721 7.42662 9.49504 8.1492 9.49504H8.16314L8.16331 9.4951ZM10.431 16.8632H12.5838V13.2431C12.5838 13.0496 12.5979 12.8556 12.6548 12.7174C12.8103 12.3301 13.1646 11.9292 13.7595 11.9292C14.5383 11.9292 14.85 12.5237 14.85 13.3953V16.8632H17.0028V13.146C17.0028 11.1547 15.9408 10.2281 14.5244 10.2281C13.3631 10.2281 12.853 10.8778 12.5697 11.3202H12.584V10.3803H10.4312C10.4593 10.9885 10.431 16.8634 10.431 16.8634L10.431 16.8632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2c35bbf09883969a592bb6730fafcf46.svg";
export { ForwardRef as ReactComponent };